/**
 * Created by Carl on 2018/5/15.
 */
import Cookies from 'js-cookie';
import axios from 'axios';
import Vue from 'vue';
let  saasConfig = require('../../../config/saasConfig.js');
let { saasProjectId }  = saasConfig;
console.log("saasProjectIdsaasProjectIdsaasProjectId" + saasProjectId);
var qs = require('qs');

let util = {
	
};
util.title = function (title) {
	title = title || 'STEM未来计划';
	window.document.title = title;
};

const ajaxUrl = '/stemapi/';
util.ajax = axios.create({
	baseURL: ajaxUrl,
	timeout: 30000
});
util.ajax.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	if (Cookies.get('stem_ooowin_token') && Cookies.get('stem_ooowin_mark') && Cookies.get('stem_ooowin_mark') != 'undefined') {
		config.headers.token = Cookies.get('stem_ooowin_token') || '';
		config.headers.mark = Cookies.get('stem_ooowin_mark') || '';
	}
	config.headers.projectId = saasProjectId;

	return config;
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

util.ajaxForm = axios.create({
	baseURL: ajaxUrl,
	timeout: 30000,
	headers: {
		post: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		projectId: saasProjectId
	}
});
util.ajaxJSON = axios.create({
	baseURL: ajaxUrl,
	timeout: 30000,
	headers: {
		post: {
			'Content-Type': 'application/json'
		}
	},

});

util.ajaxJSON.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	if (Cookies.get('stem_ooowin_token') && Cookies.get('stem_ooowin_mark') && Cookies.get('stem_ooowin_mark') != 'undefined') {
		config.headers.token = Cookies.get('stem_ooowin_token') || '';
		config.headers.mark = Cookies.get('stem_ooowin_mark') || '';
		
	}
	config.headers.projectId = saasProjectId;
	return config;
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});


util.ajaxJSON.interceptors.response.use(function (config) {
	// 在发送请求之前做些什么
	return config.data;
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

Promise.prototype.finally = function (callback) {
	let P = this.constructor;
	return this.then(
		value => P.resolve(callback()).then(() => value),
		reason => P.resolve(callback()).then(() => { throw reason })
	);
};
util.JAjax = {
	ajaxF(data, resolve, reject, need_not_logout) {//need_not_logout,不需要退出登录，为true
		let res = data.data;
		if (res.code === 1) {
			resolve(res);
		} else if (res.code === 10001) {
			// 建党100年修改
			// if (!need_not_logout) {
			// 	//  Vue.prototype.$Message.error(res.err_msg);
			// 	Cookies.remove('stem_ooowin_token');
			// 	Cookies.remove('stem_ooowin_mark');
			// 	setTimeout(function () {
			// 		window.location.href = './index.html';
			// 		// window.location.reload();
			// 	}, 500);
			// }
			reject(res);
		}else if(res.code === 10005){
			if (!need_not_logout) {
				//  Vue.prototype.$Message.error(res.err_msg);
				Cookies.remove('stem_ooowin_token');
				Cookies.remove('stem_ooowin_mark');
			}
			reject(res);
		} else {
			reject(res);
			Vue.prototype.$Message.error(res.msg);
		}
	},
	post(url, obj, need_not_logout, complete) {
		//need_not_logout,不需要退出登录，为true;complete无论是否成功都执行
		if (need_not_logout && typeof need_not_logout == Function) {
			complete = need_not_logout;
			need_not_logout = false;
		}
		return new Promise((resolve, reject) => {
			util.ajax.post(url, qs.stringify(obj)).then(
				(data) => {
					this.ajaxF(data, resolve, reject, need_not_logout);
					complete && complete();
				}).catch(function (err) {
					console.log(url + ':' + err);
					complete && complete();
				});
		})
	},
	postJSON (url, obj){
		return util.ajaxJSON.post(url,obj);
	},
	postObj(url, obj, need_not_logout, complete) {
		//need_not_logout,不需要退出登录，为true;complete无论是否成功都执行
		if (need_not_logout && typeof need_not_logout == Function) {
			complete = need_not_logout;
			need_not_logout = false;
		}
		return new Promise((resolve, reject) => {
			util.ajax.post(url, obj).then(
				(data) => {
					this.ajaxF(data, resolve, reject, need_not_logout);
					complete && complete();
				}).catch(function (err) {
					console.log(url + ':' + err);
					complete && complete();
				});
		})
	},
	postForm(url, obj) {
		return new Promise((resolve, reject) => {
			util.ajaxForm.post(url, qs.stringify(obj)).then(
				(data) => {
					this.ajaxF(data, resolve, reject);
				}).catch(function (err) {
					console.log(url + ':' + err);
				});
		})
	},
	get(url, obj, need_not_logout) {//need_not_logout,不需要退出登录，为true
		return new Promise((resolve, reject) => {
			let getUrl = "";
			if (obj == "" || obj == null) {
				getUrl = url;
			} else {
				getUrl = url + '?' + qs.stringify(obj)
			}
			if (getUrl.indexOf('?') > -1) {
				getUrl += '&_=' + Date.parse(new Date());
			} else {
				getUrl += '?_=' + Date.parse(new Date());
			}

			util.ajax.get(getUrl).then(
				(data) => {
					this.ajaxF(data, resolve, reject, need_not_logout);
				}).catch(function (err) {
					console.log(url + ':' + err);
				});
		})
	},
	h5Post(url, obj, need_not_logout) {
		//need_not_logout,不需要退出登录，为true;complete无论是否成功都执行
		if (need_not_logout && typeof need_not_logout == Function) {
			complete = need_not_logout;
			need_not_logout = false;
		}
		return new Promise((resolve, reject) => {
			util.ajax.post(url, qs.stringify(obj)).then(
				(data) => {
					//this.h5AjaxF(data, resolve, need_not_logout);
					let res = data.data;
					if (res.code === 1) {
						resolve(res);
					} else if (res.code === 10001) {
						// 建党100年修改
						// if (!need_not_logout) {
						// 	//  Vue.prototype.$Message.error(res.err_msg);
						// 	Cookies.remove('stem_ooowin_token');
						// 	Cookies.remove('stem_ooowin_mark');
						// 	setTimeout(function () {
						// 		window.location.href = './active_h5.html';
						// 	}, 500);
						// }
						resolve(res);
					} else {
						resolve(res);
					}
				}).catch(err => {
					reject(err);
				});
		})
	}

};
util.url = {
	get_teacher: "web/sys/teacher",//获取老师信息
	teacher_update: "web/sys/teacher/update",//修改老师信息
	logout: "web/sys/logout",//退出
	login: "web/sys/login",//登录
  loginBySms: "web/sys/loginBySms",//登录
	get_code: "web/sys/phoneMsg/send",//获取验证码
	register: "web/sys/register",//注册
	reset_pwd: "web/sys/pwd/reset",//重置密码
	change_pwd: "web/sys/pwd/change",//修改密码
	banner_list: "/web/banner/list",//查询banner 列表数据   1，首页顶部；2，关于我们；3，课程顶部
	get_special: "web/book/special",//获取热门和最新课程
	feedback_add: "web/feedback/add",//新增反馈
	change_avatar: "web/sys/teacher/avatarChange",//个人头像
	get_index_news: "web/news/list",//首页推荐位新闻

	get_about: "web/about/all",//查询关于我们的全部构造完成的数据

	get_subjects: "common/dictionary/subjects", //获取科目

	get_inspiration: 'web/inspiration/findAll', // 灵感列表
	inspiration_collect: 'web/collect/collectInspiration', // 收藏灵感
	inspiration_praise: 'web/inspiration/praiseInspiration', // 灵感点赞'
	inspiration_get: 'web/inspiration/findInspiration', // 查看灵感'
	inspiration_get_hot: 'web/inspiration/findHot', // '热门灵感列表'
	inspiration_collect_not: 'web/collect/delCollectInspiration', // '取消收藏灵感'

	reply_list: 'web/reply/replyByIns', // '灵感下评论列表'
	reply_put: 'web/reply/createReply', // '灵感增加/回复评论'
	reply_praise: 'web/reply/replyPraise', // '灵感评论点赞'

	wx_config: 'web/wx/getWxConfig', // '获取微信配置'
};
util.getQueryObject = (url) => {
	url = url == null ? window.location.href : url;
	var search = url.substring(url.lastIndexOf("?") + 1);
	var obj = {};
	var reg = /([^?&=]+)=([^?&=]*)/g;
	search.replace(reg, function (rs, $1, $2) {
		var name = decodeURIComponent($1);
		var val = decodeURIComponent($2);
		val = String(val);
		obj[name] = val;
		return rs;
	});
	return obj;
}

util.replaceSpaceAndBr = (str) => {
	if (str) {
		return str.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;')
	} else {
		return ""
	}
}

export default util;



